import blenderPreviewPic from "../assets/blender-preview.webp";
import jumpQueenPreviewPic from "../assets/jumpqueen-preview.webp";
import nnPreviewPic from "../assets/nn-preview.webp";
import powertownPreviewPic from "../assets/powertown-preview.webp";
import DownloadLink from "../components/DownloadLink";
import ExternalLink from "../components/ExternalLink";
import { useLanguage } from "../localization/LanguageContext";
import { renderRichText } from "../localization/renderRichText";

function MyProjectsPage()
{
    const { translation } = useLanguage();

    return (
        <div className="container-fluid d-flex flex-column">
            <div className="display-4 mb-3 mb-lg-4">{translation("my_projects_navlink")}</div>
            <div className="row gx-0 mb-4 align-items-lg-center">
                <div className="col-lg-6 order-lg-2 p-1 px-lg-3">
                    <div className="display-5 mb-2">PowerTown</div>
                    <p className="p-1">{renderRichText(translation("my_projects_powertown_paragraph"), { spa: (label) => <ExternalLink to="https://www.soc.cz">{label}</ExternalLink>, monogame: (label) => <ExternalLink to="https://monogame.net">{label}</ExternalLink>, download: (label) => <ExternalLink to="https://github.com/Dominav/PowerTown_Releases/releases">{label}</ExternalLink>})}</p>
                </div>
                <div className="col-lg-6 order-lg-1 pe-lg-2">
                    <img src={powertownPreviewPic} alt="PowerTownPreview" className="img-fluid"/>
                </div>
            </div>
            <div className="row gx-0 mb-4 align-items-lg-center">
                <div className="col-lg-6 p-1">
                    <div className="display-5 mb-2">Jump Queen</div>
                    <p className="p-1">{renderRichText(translation("my_projects_jumpqueen_paragraph"), { unity: (label) => <ExternalLink to="https://unity.com">{label}</ExternalLink>, downloadwin: (label) => <DownloadLink href="/assets/JumpQueenWindows.zip">{label}</DownloadLink>, downloadmac: (label) => <DownloadLink href="/assets/JumpQueenMacOS.zip">{label}</DownloadLink>})}</p>
                </div>
                <div className="col-lg-6 ps-lg-2">
                    <img src={jumpQueenPreviewPic} alt="JumpQueenPreview" className="img-fluid"/>
                </div>
            </div>
            <div className="p-1">
                <div className="display-5 mb-2">{translation("my_projects_other_heading")}</div>
                <p className="p-1">{renderRichText(translation("my_projects_other_paragraph"), { blender: (label) => <ExternalLink to="https://blender.org">{label}</ExternalLink>})}</p>
            </div>
            <div className="row gx-0">
                <div className="col-lg-6 pe-lg-2 mb-4">
                    <img src={blenderPreviewPic} alt="BlenderPreview" className="img-fluid" />
                </div>
                <div className="col-lg-6 ps-lg-2">
                    <img src={nnPreviewPic} alt="BlenderPreview" className="img-fluid"/>
                </div>
            </div>
        </div>
    );
}

export default MyProjectsPage;